const abortStreamListener = (
  jwPlayer: jwplayer.JWPlayer,
  onAbort: () => void,
) => {
  const handleUnload = () => {
    if (jwPlayer.getState() === 'playing') onAbort()
  }

  jwPlayer.once?.('play', () => {
    window.addEventListener('beforeunload', handleUnload)

    jwPlayer.on('remove', () => {
      window.removeEventListener('beforeunload', handleUnload)
    })
  })
}

export default abortStreamListener
